import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ParticipationComponent } from './participation/participation.component';
import { ControlsModule } from './pm-controls/controls.module';
import { PreviewData, CommonSetting, SignUp, OfflineSurvey } from './common-class/survey';
import { QuestionStringPipe } from './_pipe/question-string.pipe';
import { MatrixGroupPipe } from './_pipe/matrix-group.pipe';
import { MatrixPipe } from './_pipe/matrix-data.pipe';
import { GroupPipe } from './_pipe/group.pipe';
import { MultiGroupPipe } from './_pipe/multi-group.pipe';
import { DestroyDirective } from './_directives/destroy.directive';
import { CustomErrorsHandlerService } from './_services/custom-errors-handler.service';
import { PipeModule } from './_pipe/pipe.module';

@NgModule({
  declarations: [
    AppComponent,
    ParticipationComponent,
    QuestionStringPipe,
    MatrixGroupPipe,
    MatrixPipe,
    MatrixGroupPipe,
    GroupPipe,
    MultiGroupPipe,
    DestroyDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ControlsModule,
    PipeModule
  ],
  providers: [
    PreviewData, CommonSetting,SignUp,
    {
      provide: PreviewData,
      useValue: window['PreviewSetting']
    },
    {
      provide: CommonSetting,
      useValue: window['CommonSetting']
    },
    {
      provide: SignUp,
      useValue: window['SignUp']
    },
    {
      provide: OfflineSurvey,
      useValue: window['OfflineSurvey']
    },
    {
      provide: ErrorHandler,
      useClass: CustomErrorsHandlerService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
